if (!customElements.get('cart-drawer-upsell-carousel')) {
  customElements.define(
    'cart-drawer-upsell-carousel',
    class CartDrawerUpsellCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const slides = this.querySelectorAll('.swiper-slide');

        if (slides.length > 1) {
          this.slider = new Swiper(this.querySelector('.swiper'), {
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            cssMode: false,
            slidesPerView: 1,
            loop: true,
            speed: 600,
            spaceBetween: 25
          })
        }
      }
    }
  );
}